/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const TradeInEstimateSm = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 67 29" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M66.8 13.77c-.09-.17-2.26-4.16-8.47-4.34l-6.65-6.65a1 1 0 0 0-.68-.29h-9V0l-6 3.49L42 7V4.49h8.61l6.65 6.65a1 1 0 0 0 .7.29c4.59 0 6.53 2.39 7 3.09v3.72H60a5 5 0 1 0 0 2h5.93a1 1 0 0 0 1-1v-5a1 1 0 0 0-.13-.47zm-11.72 8.47a3 3 0 1 1 3-3 3 3 0 0 1-3 3zM28.94 11.46a1 1 0 0 0 .62-.21l6.5-5.07L34.29 5 28.6 9.46H25a13.3 13.3 0 0 1 .63 2zM47.93 19.24l-6-3.49v2.49h-4.12a5 5 0 0 0-9.8 0h-2.49a14.28 14.28 0 0 1-.68 2H28a5 5 0 0 0 9.8 0h4.08v2.49zm-15 3a3 3 0 1 1 3-3 3 3 0 0 1-3.02 3z" /><path d="M25.53 26.77l-4.36-4.36a12.18 12.18 0 1 0-1.42 1.41l4.36 4.36a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.41zM2 14.68a10 10 0 1 1 10 10 10 10 0 0 1-10-10z" fill={secondaryColor} /><path d="M14.91 14.49a3.81 3.81 0 0 0-1.91-.74l-.32-.05v-2.59a3.19 3.19 0 0 1 .79.21 3.52 3.52 0 0 1 .71.46l.12.1 1.18-1.16-.14-.12a5.13 5.13 0 0 0-1.24-.82 5 5 0 0 0-1.31-.29v-.75h-1.4v.78a5.35 5.35 0 0 0-1.09.29 2.74 2.74 0 0 0-1 .69 2.82 2.82 0 0 0-.72 2 2.63 2.63 0 0 0 .72 1.9 3.13 3.13 0 0 0 2 .87h.21V18a3.66 3.66 0 0 1-1.08-.25 3.68 3.68 0 0 1-.88-.62L9.44 17l-1.21 1.18.13.12a5 5 0 0 0 1.44 1 5.75 5.75 0 0 0 1.59.33v1h1.44v-1.07a4.59 4.59 0 0 0 1.36-.39 2.73 2.73 0 0 0 1.58-2.57 2.67 2.67 0 0 0-.86-2.11zm-3.39-.94a1.69 1.69 0 0 1-.83-.37 1 1 0 0 1-.3-.78 1.21 1.21 0 0 1 1.13-1.27zm2.11 4a2.13 2.13 0 0 1-.91.38v-2.5a2.24 2.24 0 0 1 .92.35 1 1 0 0 1 .34.87 1 1 0 0 1-.35.89z" fill={secondaryColor} />
      </g>
    </svg>
  </span>
);

TradeInEstimateSm.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

TradeInEstimateSm.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default TradeInEstimateSm;
